import { Clock, Feather, Flame, Mountain, Zap } from 'lucide-react'
import { useAppearance } from '../lib/appearance'
import { cn } from '../lib/utils'

const ICON_MAP = {
  Flame,
  Clock,
  Zap,
  Feather,
  Mountain,
} as const

/**
 * Renders the user's currently selected brand logo. Picks one of the preset
 * Lucide icons by id, or — when `logo === 'custom'` and a data URL exists —
 * renders the uploaded image. Falls back to Flame.
 */
export function BrandLogo({
  className,
  size = 20,
  strokeWidth = 2.25,
}: {
  className?: string
  size?: number
  strokeWidth?: number
}) {
  const logo = useAppearance((s) => s.logo)
  const customDataUrl = useAppearance((s) => s.customLogoDataUrl)

  if (logo === 'custom' && customDataUrl) {
    return (
      <img
        src={customDataUrl}
        alt="Logo"
        className={cn('object-contain', className)}
        style={{ width: size, height: size }}
      />
    )
  }

  // Resolve preset icon
  const iconName =
    logo === 'flame'
      ? 'Flame'
      : logo === 'clock'
        ? 'Clock'
        : logo === 'bolt'
          ? 'Zap'
          : logo === 'feather'
            ? 'Feather'
            : logo === 'mountain'
              ? 'Mountain'
              : 'Flame'
  const Icon = ICON_MAP[iconName as keyof typeof ICON_MAP] ?? Flame
  return (
    <Icon
      className={cn('text-accent shrink-0', className)}
      style={{ width: size, height: size }}
      strokeWidth={strokeWidth}
    />
  )
}
